import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import { Typography, Button, Skeleton, Modal } from "antd";
import useKeys from "./useKeys";
import axios from "axios";

const ProdKeys = ({ setCurrentPage }) => {
  const { keys, fetchKeys, isLoading } = useKeys("prod");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [currentApikey, setCurrentApikey] = useState("");

  const openModal = (api_key) => {
    setCurrentApikey(api_key);
    setOpenConfirm(true);
  }

  const handleCancel = () => {
    setOpenConfirm(false);
  };

  const handleProdKeysGeneration = () => {
    axios.post("/user/resources/access-key", { target: "prod" }).then(() => {
      fetchKeys("prod");
    });
  };

  const handleRevokeKey = (api_key) => {
    axios.delete("/user/resources/access-key?api_key=" + api_key).then(() => {
      fetchKeys("prod");
      setOpenConfirm(false);
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        rowGap: "14px",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "24px",
          borderRadius: "16px",
          border: "1px solid #507FFB",
          rowGap: "10px",
          width: "100%",
        }}
      >
        <Typography.Title level={4} style={{ width: "80%" }}>
          Production keys
        </Typography.Title>
        <Modal
          open={openConfirm}
          title="Are you sure?"
          onOk={handleRevokeKey}
          onCancel={handleCancel}
          footer={[
            <Button type="outline" onClick={handleCancel}>
              Decline
            </Button>,
            <Button type="primary" onClick={ () => handleRevokeKey(currentApikey)}>
              Accept
            </Button>,
          ]}
        >
          <p>
            You might lose access to your verification processes in case these
            production keys are active at the moment.
          </p>
          <p>
            Please make sure that you have replaced these production keys with
            the new ones before you revoke the old ones.
          </p>
        </Modal>
        {keys.map(
          (keyItem, index) =>
            keyItem.status === "active" && (
              <div
                key={keyItem.api_key}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "4px",
                  width: "100%",
                }}
              >
                <span>API Key</span>
                <div
                  style={{
                    border: "1px solid #707070",
                    borderRadius: "8px",
                    padding: "4px",
                    width: "100%",
                  }}
                >
                  <Skeleton
                    loading={isLoading}
                    active
                    title={false}
                    paragraph={{ rows: 1 }}
                  >
                    <Typography.Text copyable className="settings-api-tab-key">
                      {keyItem.api_key}
                    </Typography.Text>
                  </Skeleton>
                </div>

                <span>Secret Key</span>
                <div
                  style={{
                    border: "1px solid #707070",
                    borderRadius: "8px",
                    padding: "4px",
                    width: "100%",
                  }}
                >
                  <Skeleton
                    loading={isLoading}
                    active
                    title={false}
                    paragraph={{ rows: 1 }}
                  >
                    <Typography.Text copyable className="settings-api-tab-key">
                      {keyItem.api_secret}
                    </Typography.Text>
                  </Skeleton>
                </div>
                <Button
                  type="primary"
                  style={{ width: "90px", marginTop: "10px" }}
                  disabled={keys.length < 2}
                  onClick={() => openModal(keyItem.api_key)}
                >
                  Revoke
                </Button>
                {index == 0 && keys.length > 1 && (
                  <hr
                    style={{
                      color: "#D2D8EC",
                      width: "100%",
                      marginTop: "10px",
                    }}
                  />
                )}
              </div>
            )
        )}
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Button
            type="primary"
            style={{marginTop: "20px" }}
            onClick={() => handleProdKeysGeneration()}
            className="settings-api-tab-btn"
            disabled={keys.length >= 2}
          >
            Generate Production Access Keys
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProdKeys;
